export type CustomerTypeValue = 'commercial' | 'consumer' | null;
